export function saveScrollAnchor(anchor) {
    sessionStorage.setItem('scrollAnchor', anchor);
}

export function loadScrollAnchor() {
    const anchor = sessionStorage.getItem('scrollAnchor');
    if (anchor) {
        sessionStorage.removeItem('scrollAnchor');
        return anchor;
    }
    return null;
}

export function scrollToAnchor(anchor) {
    const element = document.querySelector(anchor);
    if (element) {
        element.scrollIntoView();
    }
}

export function initializeScrollToAnchor() {
    const anchor = loadScrollAnchor();
    if (anchor) {
        scrollToAnchor(anchor);
    }
}